export default "<pre *ngIf=\"document\">{{ document | json }}</pre>\n";